<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/BarcodeMapping'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จำนวนชุดอุปกรณ์ :</label> 
                  <treeselect
                    v-model="reTotalSet"
                    :multiple="true"
                    :options="reTotalSetOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>


              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label> 
                  <treeselect
                    v-model="rePMBrand"
                    :multiple="true"
                    :options="rePMBrandOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
 
  
            </div>
            <div class="row">
              <!-------ตัวแทน---->
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label> 
                  <treeselect v-model="pmrAgentCodes" :multiple="true" :options="pmrAgentCodesOptions" :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div> 
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrShopCodes'"
                    :name="'pmrShopCodes'"
                    :select2-options="pmrShopCodesOptions"
                    v-model="pmrShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  
                </div>
              </div> 
               <!-------ตัวแทน---->
            </div>
            <div class="row">
                 <!-------ตัวแทนย่อย---->
                <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])">
                    <div class="form-group">
                      <label>ตัวแทนจำหน่ายย่อย:</label>
                      
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'pmrSubAgentCodes'"
                        :name="'pmrSubAgentCodes'"
                        :select2-options="pmrSubAgentCodeOptions"
                        v-model="pmrSubAgentCodes"
                        ref="pmrSubAgentCodesSelect2"
                        multiple
                      ></select2>
    
                    </div>
                  </div>

                  <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])">
                    <div class="form-group">
                      <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'pmrSubAgentShopCodes'"
                        :name="'pmrSubAgentShopCodes'"
                        :select2-options="pmrSubAgentShopCodesOptions"
                        v-model="pmrSubAgentShopCodes"
                        ref="pmrShopCodesSelect2"
                        multiple
                      ></select2>
                       
                    </div>
                  </div>
                <!-------สิ้นสุดตัวแทนย่อย-->
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button
                  class="btn btn-outline-primary"
                  @click="exportPM"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
       
      rePMBrand: [],

      pmrAgentCodes: [],
      pmrAgentCodesOptions: [],

      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],

      pmrSubAgentShopCodes : [],
      pmrSubAgentShopCodesOptions : [],

      pmrShopCodes: [],  
     
      //-----------------------------
      reTotalSetOptions : [],
      reTotalSet : [],

      reTotalSetOptions : [ 
        {
          id: "1",
          label: "1",
        },
        {
          id: "2",
          label: "2",
        },
        {
          id: "3",
          label: "3",
        },
        {
          id: "4",
          label: "4",
        },
        {
          id: "5",
          label: "5",
        },
        {
          id: "6",
          label: "6",
        },
        {
          id: "7",
          label: "7",
        },
        {
          id: "8",
          label: "8",
        },
        {
          id: "9",
          label: "9",
        },
        {
          id: "10",
          label: "10",
        },
      ],
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         //pmrSubAgentCodes
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.pmrAgentCodes, 
              shopCodes  : self.pmrSubAgentCodes,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      
      rePMBrandOptions: [],
       
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
       
      self.rePMBrand = [];  
      self.reTotalSet = [];  
      self.pmrAgentCodes = [];  
      self.pmrSubAgentCodes = [];  
      self.pmrSubAgentShopCodes = [];  
      self.pmrShopCodes=[];
      
      $("#pmrShopCodes")
      .val("")
      .trigger("change");

      $("#pmrAgentCodes")
      .val("")
      .trigger("change");

      $("#pmrSubAgentShopCodes")
      .val("")
      .trigger("change");

      $("#pmrSubAgentCodes")
      .val("")
      .trigger("change");

      $("#reTotalSet")
      .val("")
      .trigger("change");

      $("#reTotalSet")
        .val("")
        .trigger("change");

      $("#rePMBrand")
        .val("")
        .trigger("change");
       
      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#pmTable").DataTable();
      table.draw();
    },
    exportPM: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportBarcodeMapping",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.pmrAgentCodes,
          SubAgentCode: self.pmrSubAgentCodes, 
          Brand: self.rePMBrand, 
          ShopId: self.pmrShopCodes,
          SubAgentShopId: self.pmrSubAgentShopCodes,
          TotalSet : self.reTotalSet  

        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            } 

            var fname = filename.split("RPT_")[1] ;   

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "รายงานจำนวนชุดอุปกรณ์_" + fname //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },

    LoadpmrAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post(
          self.$root.canShow(["AGENT_ADMIN_PM"])
            ? "/Api/Agents/AgentOptions"
            : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          {
            province_id: [],
            department: [],
            agentCodes: [],
            page: 1,
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.pmrAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
         
    LoadrePMBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/PM/ProductBrandOptions", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    ClearAfterselect: function() {
      $(`[class="vue-treeselect__input"]`).val("");
    }, 
  },
  async mounted() {
    let self = this;
 
    self.LoadrePMBrandOptions(); 
    self.LoadpmrAgentCodesOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }
  

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/BarcodeMappingReport.vue